import pageStyle from "./index.module.less";
import LeftMenu from "@/components/menu";
import Language from "@/components/language";
import User from "../components/user";
import Business from "@/components/businessSelect";
import { isLogin } from "@/lib/auth";

export default {
    name: "BaseLayout",
    data() {
        return {
            // eslint-disable-next-line no-undef
            BASE_URL,
            pageStyle
        };
    },
    computed: {
        isLogin
    },
    components: { LeftMenu, Language, User, Business }
};
